<template>
  <div class="pdfviewer-container">
    <!-- <input type="file" @change="onFileChange" accept="application/pdf" /> -->
    <div v-if="pdfUrl">
      <pdf-embed
          :source="pdfUrl"
          :page="page"
          class="pdf-scroll"
          @loaded="onPdfLoaded"
      />
      <div style="margin: 10px 0; text-align: center;">
        <button @click="prevPage" :disabled="page <= 1">Previous</button>
        <span style="margin-left: 10px;margin-right: 10px;">Page {{ page }} / {{ totalPage }}</span>
        <button @click="nextPage" :disabled="page >= totalPage">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import PdfEmbed from 'vue-pdf-embed';

export default {
  components: {
    PdfEmbed
  },
  setup() {
    const pdfUrl = ref(null);
    const page = ref(1); // 현재 페이지 번호
    const totalPage = ref(1);  // 추가
    return {pdfUrl, page, totalPage}
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type === 'application/pdf') {
        this.pdfUrl = URL.createObjectURL(file);
        this.page = 1; // 파일을 새로 열면 페이지를 1로 리셋
      } else {
        alert('PDF 파일을 선택하세요.');
      }
    },
    onPdfLoaded(pdf){
      this.totalPage = pdf._pdfInfo.numPages; // 전체 페이지 수 가져오기
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    nextPage() {
      this.page++;
    },
    viewPDF(file) {
      if (file && file.type === 'application/pdf') {
        this.pdfUrl = URL.createObjectURL(file);
        this.page = 1;
      } else {
        alert('PDF 파일을 선택하세요.');
      }
    }
  }
}
</script>

<style scoped>
::v-deep(*)
{
  all: revert;
}

.pdfviewer-container {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  height: 700px;
  margin-top: 10px;
}

.pdf-scroll {
  width: 100%;
  height: 670px;
  overflow-y: auto;
  overflow-x: auto;
}
</style>
